import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-lib-fw-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormlyFormFieldWrapperComponent extends FieldWrapper {
  public constructor() {
    super();
  }

  public get labelClass() {
    return this.props.labelClass;
  }

  public errorToShow(field) {
    return Object.keys(field.formControl.errors)?.length;
  }
}
